export const LogisticRequestType = {
  Default: 'default',
  Registration: 'registration',
  Repossession: 'repossession',
} as const;

export type LogisticRequestType =
  (typeof LogisticRequestType)[keyof typeof LogisticRequestType];

export const LOGISTIC_REQUEST_TYPES = [
  LogisticRequestType.Default,
  LogisticRequestType.Registration,
  LogisticRequestType.Repossession,
] as const;

export const LOGISTIC_REQUEST_TYPE_LABELS: Record<LogisticRequestType, string> =
  {
    [LogisticRequestType.Default]: 'Стандартная',
    [LogisticRequestType.Registration]: 'Регистрационные действия',
    [LogisticRequestType.Repossession]: 'Изъятие',
  };

export type LogisticRequestExtraFieldType =
  'string' | 'number' | 'date' | 'timestamp';

export type LogisticRequestExtraField = {
  name: string;
  title: string;
  fieldType: LogisticRequestExtraFieldType;
  requestType?: LogisticRequestType;
  productId?: number;
  counterpartyOwnerId?: number;
};

export const LOGISTIC_REQUEST_EXTRA_FIELDS: LogisticRequestExtraField[] = [
  {
    name: 'carDeliveryDate',
    title: 'Планируемая дата подачи ТС',
    fieldType: 'date',
    requestType: LogisticRequestType.Registration,
  },
  {
    name: 'carDeliveryTime',
    title: 'Планируемое время подачи',
    fieldType: 'string',
    requestType: LogisticRequestType.Registration,
  },
  {
    name: 'gibddAccountStatus',
    title: 'Статус учетной записи в ГИБДД',
    fieldType: 'string',
    requestType: LogisticRequestType.Registration,
  },
  {
    name: 'ptsType',
    title: 'Тип ПТС',
    fieldType: 'string',
    requestType: LogisticRequestType.Registration,
  },
  {
    name: 'hasFsspRestrictions',
    title: 'Наличие ограничений ФССП',
    fieldType: 'string',
    requestType: LogisticRequestType.Registration,
  },
  {
    name: 'transportationMethod',
    title: 'Способ транспортировки',
    fieldType: 'string',
    requestType: LogisticRequestType.Registration,
  },
  {
    name: 'storageAddress',
    title: 'Адрес хранения ТС',
    fieldType: 'string',
    requestType: LogisticRequestType.Registration,
  },
  {
    name: 'enforcementProceedingNumber',
    title: 'Номер исполнительного производства',
    fieldType: 'string',
    requestType: LogisticRequestType.Registration,
  },
  {
    name: 'restrictionAuthority',
    title: 'Орган, вынесший ограничение',
    fieldType: 'string',
    requestType: LogisticRequestType.Registration,
  },
  {
    name: 'hasTerminationNotice',
    title: 'Наличие уведомления о расторжении',
    fieldType: 'string',
    requestType: LogisticRequestType.Registration,
  },
  {
    name: 'inspectionDate',
    title: 'Дата ТО',
    fieldType: 'date',
    requestType: LogisticRequestType.Registration,
  },
  {
    name: 'inspectionTime',
    title: 'Время ТО',
    fieldType: 'string',
    requestType: LogisticRequestType.Registration,
  },
  {
    name: 'inspectionAccountStatus',
    title: 'Статус учетной записи',
    fieldType: 'string',
    requestType: LogisticRequestType.Registration,
  },
  {
    name: 'registrationDocumentChangeReason',
    title: 'Причина изменений',
    fieldType: 'string',
    requestType: LogisticRequestType.Registration,
  },
  {
    name: 'registrationDocumentAccountStatus',
    title: 'Статус учетной записи',
    fieldType: 'string',
    requestType: LogisticRequestType.Registration,
  },
  {
    name: 'gtnStoragePlace',
    title: 'Место хранения',
    fieldType: 'string',
    requestType: LogisticRequestType.Registration,
  },
  {
    name: 'hasValidInspection',
    title: 'Есть ли действующий ТО',
    fieldType: 'string',
    requestType: LogisticRequestType.Registration,
  },
  {
    name: 'plannedInspectionDate',
    title: 'Плановая дата осмотра',
    fieldType: 'date',
    requestType: LogisticRequestType.Registration,
  },
  {
    name: 'gtnDeregistrationStoragePlace',
    title: 'Место хранения',
    fieldType: 'string',
    requestType: LogisticRequestType.Registration,
  },
  {
    name: 'gtnDeregistrationReason',
    title: 'Причина снятия',
    fieldType: 'string',
    requestType: LogisticRequestType.Registration,
  },
];
